/**
 * Builds the list of tabs based on configuration options.
 *
 * @param {Object} options - Configuration options
 * @param {boolean} options.isLicensePlateTabDefaulted - Whether license plate tab is the default
 * @param {boolean} options.isLookUpStyleView - Whether this is a look-up style view
 * @param {boolean} options.isLicensePlateTabDefault - Whether license plate is configured as default (prop-level)
 * @param {boolean} options.renderAddressTab - Whether to include the address tab
 * @param {Object} options.tabsWithComponent - Map of tab configurations with their components
 * @param {Object} options.addressTabWithComponent - Address tab configuration with component
 * @returns {Array} The ordered list of tab configurations
 */
export function buildTabsList({
  isLicensePlateTabDefaulted,
  isLookUpStyleView,
  isLicensePlateTabDefault,
  renderAddressTab,
  tabsWithComponent,
  addressTabWithComponent,
}) {
  let tabs = isLicensePlateTabDefaulted ? tabsWithComponent.LICENSE_PLATE : tabsWithComponent.DEFAULT;

  if (isLookUpStyleView) {
    tabs = !isLicensePlateTabDefault
      ? [...tabsWithComponent.YMM_SUPPRESSED].reverse()
      : tabsWithComponent.YMM_SUPPRESSED;
  }

  if (renderAddressTab) {
    tabs = [...tabs, addressTabWithComponent];
  }

  return tabs;
}
